<template>
  <div class="form-group position-relative">
    <label v-if="label">
      {{ label }} <span v-if="required" class="text-danger">*</span>
    </label>
    <input
      :id="id"
      :name="name"
      :type="type"
      class="form-control"
      :class="{ 'is-invalid': errorMessage }"
      :placeholder="placeholder"
      v-model="inputValue"
    />
    <span
      v-if="errorMessage"
      class="error-message"
    >
      {{ errorMessage }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style scoped>
.is-invalid {
  border-color: #dc3545;
}
.error-message {
  position: absolute;
  top: 100%;
  left: 0;
  font-size: 0.875rem;
  color: #dc3545;
  margin-top: 2px;
}
.form-group {
  position: relative;
  margin-bottom: 1.5rem; /* Ensure space for the error message */
}
</style>
